// Docs
// https://marmelab.com/react-admin/Show.html#actions
// https://github.com/marmelab/react-admin/blob/master/docs/Actions.md
// https://reactjs.org/docs/conditional-rendering.html

import React from 'react';
import { TextInput, usePermissions } from 'react-admin';
import ListHeaderWithFilters from '../../../components/ListHeaderWithFilters';

const WebsitesListHeader = (props) => {
  const { permissions } = usePermissions();
  return (
    <ListHeaderWithFilters
      {...props}
      title="Consent Solutions"
      createBtnLabel="consent_solution_create"
      createBtnLabelSmall="consent_solution_create_small">
      {permissions === 'ROLE_ADMIN' ? <TextInput
        label="Search by account id"
        source="account"
        alwaysOn
      /> : null}
      <TextInput
        label="Search by solution"
        source="name"
        data-testid="search-consent-solution"
        alwaysOn
        fullWidth={true}
      />
      <TextInput
        label="Search for domain"
        source="domains.canonicalDomain"
        data-testid="search-for-domain"
        alwaysOn
        fullWidth={true}
      />
    </ListHeaderWithFilters>
  );
};


export default WebsitesListHeader;
